/* SoftSection — tenký obal nad Kartou (DESIGN-PRAVIDLA §5, 19. 10. 2026).
 *
 * Stejná věc = stejná komponenta: sekce v CRM (Tým, Smlouvy, Cíle, Leady…)
 * vypadají jako každá jiná karta v appce — nadpis `text-base`, „i“ vedle něj,
 * akce vpravo, `--surface`, `--line`, `--radius`, `--shadow-card`, `p-4/p-5`.
 *
 * API zůstává kvůli volajícím: title, extra (akce vpravo), children, className,
 * testid. Nově `info` (text do „i“ u nadpisu). `icon` a `padding` se už
 * nepoužívají — ikona u nadpisu ani vlastní odsazení karta nemá (jeden styl).
 */
import React from "react";
import Karta from "@/components/ui/Karta";

export default function SoftSection({ title, info, infoObsah, extra, children, className = "", testid }) {
  return (
    <Karta testid={testid} className={className}>
      <Karta.Hlavicka nazev={title} info={info} infoObsah={infoObsah} akce={extra} testid={testid ? `${testid}-hlavicka` : undefined} />
      <Karta.Telo>{children}</Karta.Telo>
    </Karta>
  );
}
